import i18n from "@/i18n";

// La moneda es siempre EUR (el negocio opera en euros pase lo que pase el
// idioma de la interfaz) — solo cambia el separador de miles/decimales.
const intlLocale = () => (i18n.language?.startsWith("en") ? "en-US" : "es-ES");

export const eur = (n) =>
  new Intl.NumberFormat(intlLocale(), {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 2,
  }).format(Number(n) || 0);

export const pct = (n) =>
  `${(Number(n) || 0).toLocaleString(intlLocale(), { maximumFractionDigits: 1 })}%`;

export const num = (n) =>
  (Number(n) || 0).toLocaleString(intlLocale(), { maximumFractionDigits: 2 });

export const today = () => new Date().toISOString().slice(0, 10);

export const formatDate = (d) => {
  if (!d) return "";
  const date = d instanceof Date ? d : new Date(d);
  return date.toLocaleDateString(intlLocale());
};
